import { DEAL_LABELS, DEAL_STAGE_CATEGORIES,HEX_CODES_STAGE_CATEGORIES, HEX_CODES } from "../constants/Map";

export const fetchMarkerColour = (selectedDimension, latlonData) => {
    if (selectedDimension === 'Deal Stage Category') {
      const index = DEAL_STAGE_CATEGORIES.findIndex((data) => data === latlonData.stage_category);
      return HEX_CODES_STAGE_CATEGORIES[index]
    }

    if (selectedDimension === 'Deal Label') {
      const index = DEAL_LABELS.findIndex((data) => data === latlonData.stagelabel)
      return HEX_CODES[index]
    }

    if (selectedDimension === 'Relation with Lead & Pearson') {
      if (latlonData.relationship_w_lead && latlonData.relationship_w_pearson) {
        return HEX_CODES[0];
      }
      
      if (latlonData.relationship_w_lead) {
        return HEX_CODES[1];
      }

      if (latlonData.relationship_w_pearson) {
        return HEX_CODES[2];
      }

      if (!latlonData.relationship_w_lead && !latlonData.relationship_w_pearson) {
        return HEX_CODES[3];
      }
    }

    return "#97D6A5";
  };

  

  export const latlonDataWithColors = (selectedDimension, item) =>{


    // console.log("dimension:",selectedDimension )
    console.log("item:",item )

    if (selectedDimension === 'Deal Stage Category') {
      const index = DEAL_STAGE_CATEGORIES.findIndex((category) => category === item);
return HEX_CODES_STAGE_CATEGORIES[index];
      console.log(HEX_CODES[index])
    } 
    if (selectedDimension === 'Deal Label') {
      
      const index = DEAL_LABELS.findIndex((category) => category === item)
      return HEX_CODES[index]
    
      }

    }
    

  

 